'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = require('../lib/check');

var _DataStoreNamespace = require('./DataStoreNamespace');

var _DataStoreNamespace2 = _interopRequireDefault(_DataStoreNamespace);

var _Api = require('../api/Api');

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class DataStore
 *
 * @description
 * Represents the dataStore that can be interacted with. This can be used to get instances of DataStoreNamespace, which
 * can be used to interact with the namespace API.
 *
 * Example usage:
 * ```js
 * import init from 'd2';
 * init({baseUrl: '/dhis/api'})
 *   .then((d2) => {
 *     d2.dataStore.get('namespace').then(namespace => {
 *          namespace.get('key').then(value => console.log(value))
 *      });
 *   });
 * ```
 */

var DataStore = function () {
    function DataStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, DataStore);

        this.endPoint = 'dataStore';

        this.api = api;
    }

    /**
     * Retrieves a list of keys for the given namespace, and returns an instance of DataStoreNamespace that
     * may be used to interact with this namespace. See {@link DataStoreNamespace}.
     *
     * Note that a namespace cannot exist without at least one key-value pair, for this reason
     * there is no 'create'- method. It is therefore advised to call this method with autoLoad = false
     * if you are creating a namespace (or you will get a 404-error in the console, as it
     * tries to load a namespace that does not exist).
     *
     * Example for creation of a new namespace
     * '''js
     * d2.dataStore.get('new namespace', false).then(namespace => {
     *     namespace.set('new key', value);
     *'''
     * @param namespace to get.
     * @param autoLoad if true, autoloads the keys of the namespace from the server
     * before the namespace is created. If false, an instance of he namespace is returned without any keys.
     *  Default true
     * @returns {Promise<DataStoreNamespace>} An instance of a DataStoreNamespace representing the namespace that can be interacted with.
     */


    _createClass(DataStore, [{
        key: 'get',
        value: function get(namespace) {
            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!autoLoad) {
                return new Promise(function (resolve) {
                    resolve(new _DataStoreNamespace2.default(namespace));
                });
            }

            return this.api.get([this.endPoint, namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    return new _DataStoreNamespace2.default(namespace, response);
                }
                throw new Error('The requested namespace has no keys or does not exist.');
            }).catch(function (e) {
                if (e.httpStatusCode === 404) {
                    // If namespace does not exist, provide an instance of DataStoreNamespace
                    // so it's possible to interact with the namespace.
                    return new _DataStoreNamespace2.default(namespace);
                }
                throw e;
            });
        }

        /**
         * Retrieves a list of all public namespaces on the server.
         * @returns {Promise} with an array of namespaces.
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            return this.api.get(this.endPoint).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    return response;
                }
                throw new Error('No namespaces exist.');
            });
        }

        /**
         * Deletes a namespace
         * @param namespace to delete
         * @returns {Promise} with the response from the API.
         */

    }, {
        key: 'delete',
        value: function _delete(namespace) {
            return this.api.delete([this.endPoint, namespace].join('/'));
        }

        /**
         * @method getDataStore
         * @static
         *
         * @returns {DataStore} Object with the dataStore interaction properties
         *
         * @description
         * Get a new instance of the dataStore object. This will function as a singleton, when a DataStore object has been created
         * when requesting getDataStore again the original version will be returned.
         */

    }], [{
        key: 'getDataStore',
        value: function getDataStore() {
            if (!DataStore.getDataStore.dataStore) {
                DataStore.getDataStore.dataStore = new DataStore();
            }

            return DataStore.getDataStore.dataStore;
        }
    }]);

    return DataStore;
}();

exports.default = DataStore;
//# sourceMappingURL=DataStore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/datastore/DataStore.js
// module id = 368
// module chunks = 0